/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_SavingInputs */

const en_settings_profile_saving = /** @type {(inputs: Settings_Profile_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Settings_Profile_SavingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_profile_saving = /** @type {((inputs?: Settings_Profile_SavingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_SavingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_profile_saving(inputs)
});
export { settings_profile_saving as "settings.profile.saving" }